module.exports = __webpack_public_path__ + "static/media/scene-replace.473ca51e.png";